/**
 * @generated SignedSource<<2b3237facd1b2e3c6b7f039dd0c1ae3d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResultCql_AtlassianSearchPage$data = {
  readonly " $fragmentSpreads": FragmentRefs<"confluenceSearchResponse_AtlassianSearchPage">;
  readonly " $fragmentType": "searchResultCql_AtlassianSearchPage";
};
export type searchResultCql_AtlassianSearchPage$key = {
  readonly " $data"?: searchResultCql_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultCql_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchResultCql_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "confluenceSearchResponse_AtlassianSearchPage"
    }
  ],
  "type": "ConfluenceSearchResponse"
};

(node as any).hash = "cd25c423f4524a66fa1d1282afb1b2aa";

export default node;
